import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface TailoringState {
  products: {
    productId: string;
    lastUpdate: Date;
    lastUsed: Date;
  }[];
}

export interface TailoringActions {
  setUpdatedAt: (id: string, lastUpdate: Date) => void;
}

export const useTailoringStore = create<TailoringState & TailoringActions>()(
  persist(
    (set) => ({
      products: [],
      setUpdatedAt: (id, lastUpdate) =>
        set((state) => {
          const now = new Date();
          // find the product and update it, else add it
          const product = state.products.find((product) => product.productId === id);

          if (product) {
            product.lastUpdate = lastUpdate;
            product.lastUsed = now;
          } else {
            state.products.push({
              productId: id,
              lastUpdate,
              lastUsed: now,
            });
          }
          // sort by last used but make sure that a and b is a date
          state.products.sort((a, b) => {
            if (a.lastUsed instanceof Date && b.lastUsed instanceof Date) {
              return a.lastUsed.getTime() - b.lastUsed.getTime();
            }
            return 0;
          });

          // make sure we don't store more than 100 products
          if (state.products.length > 100) {
            state.products = state.products.slice(0, 100);
          }
          return { products: state.products };
        }),
    }),
    {
      name: 'tailoring-store',
    },
  ),
);
